var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo2 = function SvgInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.25,
    rx: 8.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    d: "M7.98 4.99a.88.88 0 0 1 .41-.53c.21-.125.465-.177.716-.147.24.035.462.136.632.287s.28.346.315.555c.01.053.014.11.02.18l.01.12a.1.1 0 0 1-.004.041q-.01.039-.02.088-.028.164-.101.318a.9.9 0 0 1-.374.432 1.13 1.13 0 0 1-.594.163h-.013c-.22.007-.435-.05-.611-.164a.84.84 0 0 1-.36-.459 1.55 1.55 0 0 1-.026-.885m3.003 7.342c-.844.532-1.8 1.136-2.976 1.345a1 1 0 0 1-.175.014l-.06.002h-.028a1 1 0 0 1-.391-.062.85.85 0 0 1-.316-.209.8.8 0 0 1-.156-.373.74.74 0 0 1 .058-.393l.609-1.716q.42-1.182.838-2.367a.5.5 0 0 0 .03-.175.5.5 0 0 0-.194.011 3 3 0 0 0-.292.118 2.5 2.5 0 0 1-.372.144.74.74 0 0 1-.488-.101.2.2 0 0 1-.06-.062.15.15 0 0 1-.02-.078.41.41 0 0 1 .127-.32c.952-.708 1.787-1.071 2.705-1.18a2 2 0 0 1 .296-.017 1 1 0 0 1 .395.039c.126.04.24.105.331.19q.101.15.113.325a.64.64 0 0 1-.07.333l-.278.819q-.568 1.69-1.132 3.383a.4.4 0 0 0-.002.152.4.4 0 0 0 .137-.007c.148-.058.291-.125.435-.192s.281-.132.426-.19a.54.54 0 0 1 .47.027q.086.061.134.146.049.086.052.18a.26.26 0 0 1-.045.122.3.3 0 0 1-.101.092"
  })));
};
export default SvgInfo2;